import { connect } from 'react-redux';
import { selectors } from '../../../../root/reading/root';
import { hideSecondAttemptBulkInvalidationModal } from '../../../../api/modals/reading/modalsActions';
import SecondAttemptBulkInvalidationModal from '../../../../components/secondAttemptBulkInvalidationModal/SecondAttemptBulkInvalidationModal';
import { invalidateD8SecondAttemptResults } from '../../../../api/results/reading/resultActions';

const mapStateToProps = state => {
    return {
        isSecondAttemptBulkInvalidationModalShown:
            selectors.isSecondAttemptBulkInvalidationModalShown(state),
        studentInfo: selectors.getStudentInfoForSecondAttemptBulkInvalidation(state),
    };
};
const mapDispatchToProps = dispatch => ({
    hideSecondAttemptBulkInvalidationModal: () =>
        dispatch(hideSecondAttemptBulkInvalidationModal()),

    invalidateD8SecondAttemptResults: studentId =>
        dispatch(invalidateD8SecondAttemptResults(studentId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SecondAttemptBulkInvalidationModal);
